import { createLucideIcon } from "lucide-react";

export const ArrowLeftRight = createLucideIcon(
    "ArrowLeftRight",
    [
        [
            "path",
            {
                d: "M17 20L19.4629 17.7071C19.821 17.3738 20 17.2071 20 17C20 16.7929 19.821 16.6262 19.4629 16.2929L17 14",
                key: "33x16",
            },
        ],
        [
            "path",
            {
                d: "M19 16.9999L4 16.9999",
                key: "1u5wgv",
            },
        ],
        [
            "path",
            {
                d: "M5 6.99988L20 6.99988",
                key: "1apgo7",
            },
        ],
        [
            "path",
            {
                d: "M7 4L4.53708 6.29289C4.17903 6.62623 4 6.79289 4 7C4 7.20711 4.17903 7.37377 4.53708 7.70711L7 10",
                key: "lxy0ck",
            },
        ],
    ],
);
